import React from 'react';
import { ArrowRightIcon } from 'lucide-react';
import { trackInitiateCheckout } from '../../utils/metaPixel';
interface CtaButtonProps {
  label: string;
  microcopy?: string;
  tone?: 'primary' | 'light';
  href?: string;
  className?: string;
}
export function CtaButton({
  label,
  microcopy,
  tone = 'primary',
  href = '#offer',
  className = ''
}: CtaButtonProps) {
  const isLight = tone === 'light';
  const isExternal = href.startsWith('http');
  return <div className={`flex w-full flex-col items-center ${className}`} data-id="element-240" data-mp="1m3l563wcjocl">
      <a href={href} onPointerDown={() => {
      if (isExternal) trackInitiateCheckout();
    }} onClick={() => {
      if (isExternal) trackInitiateCheckout();
    }} {...isExternal ? {
      target: '_blank',
      rel: 'noopener noreferrer'
    } : {}} className={['group inline-flex w-full max-w-md items-center justify-center gap-3 rounded-full px-6 py-4 text-center', 'font-sans text-[0.78rem] font-semibold uppercase tracking-label sm:text-sm', 'transition-[transform,background-color,box-shadow] duration-200 ease-out', 'hover:-translate-y-0.5 active:translate-y-0', 'focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-4 focus-visible:outline-gold', isLight ? 'bg-ivory text-forestDeep shadow-lift hover:bg-white' : 'bg-forest text-ivory shadow-card hover:bg-forestDeep'].join(' ')} data-id="element-241" data-mp="1qxpakipyrobk">
        <span data-id="element-242" data-mp="1trs6khlsl7vs">{label}</span>
        <ArrowRightIcon className="h-4 w-4 shrink-0 transition-transform duration-200 ease-out group-hover:translate-x-1" aria-hidden="true" data-id="element-243" data-mp="1tsjr8xdupl7a" />
      </a>
      {microcopy ? <p className={`mt-3 text-center text-[0.7rem] uppercase tracking-label ${isLight ? 'text-ivory/70' : 'text-muted'}`} data-id="element-244" data-mp="22r5akur5d494">
          {microcopy}
        </p> : null}
    </div>;
}